
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import Spinner from 'vux/src/components/spinner/index.vue'

import util from "@/javascript/util";
import bus from "@/javascript/bus";
import validate from "@/javascript/validate";

export default {
components: {
Group,
Cell,
XInput,
XButton,
Toast,
Spinner,
},
data() {
return {
minHeight: 0,
isWeiXin: util.isWeiXin(),
phoneNumber: "",
mobileCoder: "",
toast: {
text: "",
show: false,
},
coderBtn: {
text: "获取验证码",
state: true,
},
spinnerShow: false,
};
},
beforeCreate() {
if (bus != undefined && bus.userInfo.access_token) {
localStorage.setItem("userInfo", JSON.stringify(bus.userInfo));
sessionStorage.setItem("userInfo", JSON.stringify(bus.userInfo));
this.$router.push({ name: "center" });
}
},

mounted() {
document.title = this.PAGE_TITLE + "登录";
this.minHeight = document.documentElement.clientHeight;
},
created() {
this.wxCheckuserInfo()
},
methods: {
getMobileCoder() {
if (validate.Mobile(this.phoneNumber)) {
if (!this.coderBtn.state) {
return;
} else {
this.spinnerShow = true;

let time = 60;
const self = this,
timer = setInterval(() => {
if (time > 1) {
time--;
self.coderBtn.text = time + "秒后重发";
self.coderBtn.state = false;
self.spinnerShow = false;
} else {
self.coderBtn.text = "获取验证码";
self.coderBtn.state = true;
clearInterval(timer);
}
}, 1000);
console.log('=========================');
this.$http.post("/api/wtcp-sms/public/sms/sendCaptcha?phone=" + this.phoneNumber + "&frontAppCode=121001").then((response) => {
if (response.data.status != 1) {
this.spinnerShow = false;
this.toast.text = response.data.msg;
this.toast.show = true;
}
});
}
} else {
this.toast.text = "请输入正确手机号码";
this.toast.show = true;
}
},
/**
* @msg: 参数加密
* @param {Object} data 需要加密的一层对象
* @return {Object} data 加密后的对象 以及 data.redisKey 私钥
*/
encryption(data) {
let _this = this;
return new Promise(function (resolve, reject) {
_this.$http.get("/api/wtcp-oauth/user/getPublicKey").then((res) => {
if (res.data.status == "1") {
let publicKey = res.data.data.publicKey;
Object.keys(data).map((key) => {
data[key] = _this.$getRsaCode(publicKey, data[key]);
return key
});
data.redisKey = res.data.data.redisKey;
resolve(data);
} else {
reject();
}
})
.catch(() => {
reject();
});
});
},

login() {
if (!validate.Mobile(this.phoneNumber)) {
this.toast.text = "请输入正确手机号码";
this.toast.show = true;
} else if (this.mobileCoder === "") {
this.toast.text = "请输入验证码";
this.toast.show = true;
} else {

this.$http.get("/api/wtcp-oauth/public/publicuser/validPhone?phone=" + this.phoneNumber + "&deptCode=" + this.DEPT_CODE.DEPTCODE).then((response) => {
const status = response.data.status;
if (status === 0) {

const param = {
username: this.phoneNumber,
password: this.mobileCoder,
deptcode: this.DEPT_CODE.DEPTCODE,
};
this.encryption({
password: this.mobileCoder,
}).then((data) => {
const regParam = {
password: param.random,
phone: param.username,
username: param.username,
validateCode: param.password,
deptCode: param.deptcode,
};
this.$http.post("/api/wtcp-oauth/public/publicuser?redisKey=" + encodeURIComponent(data.redisKey), regParam).then((response) => {
if (response.data.status === 0) {
this.toast.text = response.data.data;
this.toast.show = true;
} else {
localStorage.setItem("userInfo", JSON.stringify(response.data.data));
sessionStorage.setItem("userInfo", JSON.stringify(response.data.data));
if (localStorage.getItem("my_redirect_url")) {
this.$router.push({
path: localStorage.getItem("my_redirect_url"),
});
} else {
this.$router.go(-1);
}
}
});
});
} else {

this.loginFun();
}
});
}
},

wxLogin() {
if (util.isWeiXin()) {
console.log('++++微信授权+wxLogin++++')
localStorage.setItem('wxLoginTime', 'true')
window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + this.WX_APPID + '&redirect_uri=' + encodeURIComponent(this.WX_REDIRECT_URI + '/center') + '&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect'
}
},
loginFun() {
this.encryption({
password: this.mobileCoder,
username: this.phoneNumber,
}).then((data) => {
this.$http.post("/api/wtcp-oauth/login?auth_type=public&grant_type=mobile&password=" + encodeURIComponent(data.password) +
"&deptCode=" + this.DEPT_CODE.DEPTCODE + "&username=" + encodeURIComponent(data.username) +
"&redisKey=" + encodeURIComponent(data.redisKey)
).then((response) => {
if (response.data.error != null) {
this.toast.text = response.data.error;
this.toast.show = true;
} else {
localStorage.setItem("userInfo", JSON.stringify(response.data));
sessionStorage.setItem("userInfo", JSON.stringify(response.data));
if (localStorage.getItem("my_redirect_url")) {
this.$router.push({
path: localStorage.getItem("my_redirect_url"),
});
} else {
this.$router.go(-1)
}

}
});
});
},
wxCheckuserInfo() {
const _this = this
if (util.isWeiXin() && util.getQueryString('state') == 'STATE' && util.getQueryString('code')) {

_this.$http.get('/wxauth/wx/loginCheck?code=' + util.getQueryString('code') + '&type=' + _this.WX_LOGIN_TYPE).then((response) => {
let resData = response.data
if (resData.status === 1) {
let wxInfo = resData.data
localStorage.setItem('wxUserInfo', JSON.stringify(wxInfo))
sessionStorage.setItem('wxUserInfo', JSON.stringify(wxInfo))

_this.$http.get('/api/wtcp-oauth/wx/userRelation/' + wxInfo.unionid + '?deptCode=' + _this.DEPT_CODE.DEPTCODE).then((response) => {
let wxBindState = response.data
if (wxBindState.status === 1) {
if (wxBindState.data.access_token) {
bus.$set(bus, 'userInfo', wxBindState.data)
localStorage.setItem('userInfo', JSON.stringify(wxBindState.data))
sessionStorage.setItem('userInfo', JSON.stringify(wxBindState.data))
_this.$nextTick(function () {
_this.$router.push({ name: 'center' })
})
} else {

_this.$router.push({ path: '/relation' })
}
} else {

_this.$router.push({ path: '/relation' })
}
})
}
})
}
}

},
};
